import { render, staticRenderFns } from "./SameDayRecPromoBanner.vue?vue&type=template&id=092b1a24&scoped=true"
import script from "./SameDayRecPromoBanner.vue?vue&type=script&lang=ts"
export * from "./SameDayRecPromoBanner.vue?vue&type=script&lang=ts"
import style0 from "./SameDayRecPromoBanner.vue?vue&type=style&index=0&id=092b1a24&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092b1a24",
  null
  
)

export default component.exports